module.exports = __webpack_public_path__ + "img/em12.5ad09ce9.jpg";